import { render, staticRenderFns } from "./NavigationItemIcon.vue?vue&type=template&id=04b62ea0&"
import script from "./NavigationItemIcon.vue?vue&type=script&lang=js&"
export * from "./NavigationItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports